export default "__VITE_ASSET__PGgb5jgZ__"